// Copyright ©️ 2026 eVolve MEP, LLC

import type { HexTriplet } from '@evolvemep/api-ts';
import { ColorSwatch, getThemeColor, type MantineColor, useMantineTheme } from '@mantine/core';

import { AgGridStyleTooltip } from 'components/Mantine/AgGridStyleTooltip';

type Props = {
  color: MantineColor | HexTriplet;
  tooltip?: string;
  size?: number;
};

/**
 * Small colored dot used throughout the status editor to indicate a state or custom status.
 * Entity-agnostic — pass the resolved color and tooltip directly.
 */
export const StatusPoint = ({ color, tooltip, size = 10 }: Props) => {
  const theme = useMantineTheme();
  return (
    <AgGridStyleTooltip withinPortal withArrow label={tooltip ?? ''} hidden={!tooltip} openDelay={0}>
      <ColorSwatch size={size} color={getThemeColor(color, theme)} withShadow={false} />
    </AgGridStyleTooltip>
  );
};
